export default {

    // меню
    'Заявки': '申请',
    Заказы: '订单',
    'Новый заказ': '新的订单',
    'Билеты в музеи': '博物馆门票',
    'Подать график': '提交表格',
    'Радио/Аудиогид': '耳机/讲解器',
    Архив: '草稿',
    Отчеты: '报告',
    Сверка: '对账',
    Оплата: '支付',
    'Оплата Wechat': '微信支付',
    'Оплата заявок': '支付订单',
    'История платежей': '支付记录',
    'Прайс-лист': '价格表',
    'Продление лицензий': '证件延期',
    'Мои лицензии': '我的证件',
    Продление: '延期',
    Информация: '信息',
    Новости: '新闻',
    Транспорт: '交通',
    'О компании': '关于公司',
    Договор: '合同',
    'Договор оферты': '合同价',
    'Политика возврата': '退货政策',
    'Поиск по ref, номеру заявки, дате или объекту': '按ref，订单号，日期或宫殿搜索',
    Настройки: '设置',
    Помощь: '帮助',
    'Обратная связь': '与您联系',
    Выйти: '退出',
    'Старая версия сайта': '网页旧版本',
    'ООО «АВАНГАРД ТРАВЕЛ ГРУПП»': '«АВАНГАРД ТРАВЕЛ ГРУПП»责任有限公司',

    // заказы
    'Нет предстоящих заказов': '没有以前订单',
    'Выберите форму заказа': '选择订单形式',
    'Заказать билеты в музей': '在博物馆里订票',
    'Заказать Радио/Аудиогиды': '预定耳机/讲解器',
    Заявка: '预定',
    'В обработке': '处理中',
    'Подтврждена': '已确定',
    'Лист ожидания': '等待名单',
    'Аннулирована': '已取消',
    'Отклонена': '已拒绝',
    'Подтвержденное время:': '确定时间',
    'Вход': '登陆',
    'ПОДРОБНЕЕ': '详细',
    'ИЗМЕНИТЬ': '更改',
    'ГДЕ СОТРУДНИК': '工作人员在哪',
    'АННУЛИРОВАТЬ': '取消',
    'В АРХИВ': '在草稿箱',
    'Сотрудник на объекте': '工作人员在博物馆',
    'Сотрудник не на объекте': '工作人员不在博物馆',
    'Но вы можете связаться с нами:': '您可以和我们取得联系',
    'Аннулировать': '取消',
    'Хотите аннулировать заявку?': '想要取消订单',
    'Аннулированная заявка попадет в архив и восстановить ее будет невозможно': '取消的申请将在草稿箱且无法被恢复',
    'Отмена': '取消',
    'Дата и время:': '日期和时间',
    'Имя гида:': '导游名字',
    'Не заполнено': '没有填写',
    'Телефон гида:': '导游电话',
    'Пожелания:': '意见',
    'Подтвержденное время и вход:': '确定时间和进入',
    'Билеты:': '门票',
    'Дополнительные услуги:': '其它服务',
    'Причина отклонения:': '取消原因',
    'Информация о группе:': '团队信息',
    'Доп.услуги:': '其它服务',
    'Доп.информация:': '其它信息',
    'График': '表格',
    'Гид': '导游',
    'Заказать': '预定',

    // новый заказ
    'Информация о музее': '博物馆信息',
    'Выберите категорию группы (РФ или ИГ), музей, дату и время': '选择类别（俄罗斯联邦和外籍），博物馆，日期和时间',
    'Выберите категорию группы': '选择团队类别',
    'Выберите музей': '选择博物馆',
    'Выберите объект': '选择设施',
    Далее: '更多',
    'Выберите дату': '选择日期',
    'Выберите время': '选择时间',
    'Информация о группе': '团队信息',
    'Выберите кол-во билетов': '选择门票数量',
    'Выберите страну': '选择国家',
    Назад: '后退',
    'Доп. услуги': '其它服务',
    'Выберите дополнительные услуги': '选择其它服务',
    'Кол-во гидов сопровождающих (если нет лицензии)': '陪同导游数量（如无宫殿讲解证件）',
    'Необходим если у гида нет лицензии в выбранный музей': '如果导游没有所选择博物馆的讲解证则是必要的',
    'Доп. информация': '其它信息',
    'Информация о гиде и пожелания': '关于导游的信息和意见',
    'Ref номер (необязательно)': 'Ref号（非必要）',
    'Уникальный номер группы / вспомогательный номер для ваших целей': '团队的唯一编号',
    'Имя гида': '导游名字',
    'Телефон гида': '导游电话',
    Пожелания: '意见',
    'В поле "Пожелания" укажите:': '在“要求”字段中指定：',
    'адрес и время получения': '取票地址和时间',
    'адрес и приблизительное время возврата оборудования': '归还设备的地址和大约时间',
    Отправить: '发送',
    'Пожалуйста, ожидайте': '请等待',
    'Успешно!': '已成功',
    'Заказ создан': '订单已创建',
    'Ошибка:': '错误',
    Ок: '好的',
    'Кол-во взрослых': '成年人数量',
    'Кол-во детей': '儿童数量',
    'итого:': '总计',
    'чел. (надо': '人（需要',
    'экскурс.обсл.)': '游览服务',
    'гид. или сопровожд.)': '导游或陪同导游',
    'Радиогид': '讲解器',
    'Экскурсия ведется лицензионным гидом': '有讲解证的导游进行讲解',
    'Аудиогид': '耳机接收器',
    'Экскурсия ведется при помощи технических средств на языке группы': '佩戴游览团队语言的讲解设备游览',
    'Кол-во гидов с лицензией': '有讲解证导游的数量',
    'Кол-во сопровождающих': '陪同导游的数量',
    'Удалить': '删除',
    'Отправить заказ': '发送订单',
    'Добавить группу': '添加团队',
    'Группа': '团队',

    // архив
    'Номер заявки или ref': '订单号或ref',
    Объект: '对象',
    'Номер заявки': '订单号',
    Все: '全部',
    'Дата посещения с': '游览日期从',
    'Дата посещения по': '游览日期到',
    Найти: '搜索',
    'Заказов согласно фильтру не найдено': '未找到符合过滤器的订单',
    Ошибка: '错误',
    'Любой номер': '任何号',

    // сверка
    Сформировать: '生成',
    'Файл сверки': '对账单文件',
    'Для скачивания сформированного файла сверки нажмите на конпку "Скачать".': '要下载生成的对账单文件，请单击“下载”按钮。',
    'Скачать': '下载',

    // оплата заявок
    'Оплатить заявки': '支付订单',
    'Номера ваучеров или заявок для оплаты (через запятую)': '要支付的凭证号或订单号（用逗号分隔）',
    'Введите номера ваучеров или заявок для оплаты': '输入要支付的凭证号或订单号',
    'ФИО или название организации': '姓名或单位名称',
    'Введите ФИО или название организации': '输入姓名或单位名称',
    Email: '邮箱',
    'Введите Email': '输入邮箱',
    'Сумма к оплате': '支付金额',
    'Введите сумму к оплате': '输入支付金额',
    'Согласен с договором оферты': '同意合同',
    'Перейти к оплате': '去付款',
    'Подождите,': '等待',
    'принимаем': '接受',
    'оплату...': '支付',
    'Заказ успешно оплачен!': '成功支付订单',
    'Ваш заказ': '您的订单',
    'успешно оплачен. Спасибо за покупку!': '支付成功！谢谢惠顾！',
    'Что-то пошло не так!': '出了些小问题！',
    'При оплате заказа': '在支付订单时',
    'произошла ошибка!': '出了些小问题！',
    'Cчет успешно сформирован!': '账单已成功生成！',
    'Вы можете открыть его нажав кнопку ниже': '打开订单，按下方按钮',
    'Открыть счет': '打开账单',
    'Физическим лицам': '个人',
    'Юридическим лицам': '法人',
    'Для формирования счета на оплату введите номера ваучеров или заказов, укажите реквизиты компании и точную сумму:': '为支付生成订单，需要输入单号或订单，注明公司账号信息和确认金额',
    'Для оплаты введите номера ваучеров или заявок и укажите точную сумму для оплаты:': '支付请输入单号或订单，输入准确金额支付',
    'Название организации': '单位名称',
    'Юридический адрес': '法律地址',
    'Сформировать счет': '创建账单',
    'Расчетный счет': '结算账户',
    'ИНН': '纳税识别号',
    'КПП': '纳税人登记原因代码',
    'Банк': '银行',
    'Полное название банка (для формирования акта). Например: ': '银行 银行全程。例如：',
    'БИК Банка': '银行统一代码',
    'Корреспондентский счет': '代理银行账户',

    // история платежей
    'Номер платежа': '支付号',
    Ваучеры: '单',
    'Способ оплаты': '谢谢支付',
    'Время и дата оплаты': '支付时间和日期',
    Сумма: '金额',
    Статус: '状态',
    'Платежи отсутствуют': '没有付款',

    // прайс-лист
    'Прайс-лист для иностранных групп': '外国团队价格表',
    'Актуальный файл с ценами для иностранных групп.': '国外团体最新的价格',
    Открыть: '打开',
    'Прайс-лист для российских групп': '俄罗斯团体价目表',
    'Актуальный файл с ценами для российских групп.': '俄罗斯团体最新的价格',

    // лицензии
    'Добавить лицензию': '添加许可证',
    'В настоящий момент нет сохраненных лицензий, вы можете добавить их.': '暂时还没有保存讲解证，您可以添加',
    'Добавить': '添加',
    'Музей': '博物馆',
    'Номер лицензии': '讲解证号',
    'Стаж (лет)': '经验（年）',
    'Дата окончания': '截止日期',
    'Основной язык': '基本语言',
    'Дополнительные языки': '附加语言',

    // о компании
    'ИНН:7841027155': 'ИНН:7841027155',
    'КПП: 784101001': 'КПП: 784101001',
    'ОГРН: 1157847276003': 'ОГРН: 1157847276003',
    'ОКПО: 25885413': 'ОКПО: 25885413',
    'Расчетный счет: 40702810603260000188': 'Расчетный счет: 40702810603260000188',
    'Банк: Филиал "Центральный" Банка ВТБ (ПАО)': 'Банк: Филиал "Центральный" Банка ВТБ (ПАО)',
    'БИК: 044525411': 'БИК: 044525411',
    'Корр. счет: 30101810145250000411': 'Корр. счет: 30101810145250000411',
    'Юридический адрес: 191186, Санкт-Петербург г, вн.тер. г. муниципальный округ Дворцовый округ, наб Канала Грибоедова, д. 5, литера Е, помещ. Ч.ПОМ. 19-Н ОФ.405': 'Юридический адрес: 191186, Санкт-Петербург г, вн.тер. г. муниципальный округ Дворцовый округ, наб Канала Грибоедова, д. 5, литера Е, помещ. Ч.ПОМ. 19-Н ОФ.405',
    'Email: info@avangard-travel.ru': '邮箱：info@avangard-travel.ru',
    'Телефон: (812) 640-02-28': '电话：(812) 640-02-28 ',

    // договор
    'Вы можете посмотреть договор с ООО "Авангард Травел Групп".': '您可以看到和"Авангард Травел Групп"责任有限公司的合同',

    // договор оферты
    'Вы можете посмотреть договор оферты с ООО "Авангард Травел Групп".': '您可以查看與 Avangard Travel Group LLC 的合同。',

    // политика возврата
    'Вы можете посмотреть политику возврата.': '您可以查看退订政策',

    // настройки
    'Имя:': '名字',
    'Телефон:': '电话',
    'Страна:': '国家',
    'Информация о гиде': '导游信息',
    'Заполните информацию и подавайте заявки еще быстрее': '填写信息提交订单更加快捷',
    Имя: '名字',
    Телефон: '电话',
    'Выберите страницу': '选择国家',
    'Использовать в заказе?': '在订单中使用？',
    Сохранить: '保存',
    'Являетесь ли вы туристической фирмой / юридическим лицом': '您是否是旅行社/法人',
    'Юридическое лицо': '法人',
    'Для выставления счетов': '开发票',

    // форма логина
    Логин: '账号',
    Пароль: '密码',
    Войти: '登陆',
    'Выберите язык': '选择语言',
    'У вас нет аккаунта?': '您没有账户？',
    'Зарегистрироваться': '注册',
    'Добро пожаловать!': '欢迎使用',
    'Будем рады видеть вас среди наших клиентов! Пожалуйста, уделите немного времени на заполнение формы ниже. Вскоре мы отправим вам все необходимые инструкции на указанный адрес электронной почты.': '我们非常高兴您能够在我们的客户群体里！请空出一些时间填写一下下方表格。很快我们将会发送使用说明到您指定的邮箱。',
    'Фамилия': '姓',
    'Физ.лицо': '个人',
    'Юр.лицо': '法人',
    'Отчество': '父称',
    'У вас есть аккаунт?': '您已申请账户？',
    'Название фирмы': '公司名称',
    'БИК': 'БИК',
    'ФИО контактного лица': '联系人姓名',
    'Заявка принята!': '申请已递交',
    'Спасибо за вашу заявку! В ближайшее время на указанный вами адрес электронной почты мы отправим все необходимые инструкции.': '感谢您的申请！ 我们很快就会将所有使用说明发送到您提供的邮件里。',
    'Закрыть': '关闭',

    // уведомление
    'Теперь можно оплатить заявки онлайн, включая оплату от юридических лиц!': '現在您可以在線支付申請費用，包括來自法律實體的付款！',
    'Мы рады сообщить, что теперь вы можете оплатить заявки на нашем сайте, используя банковскую карту или QR-код системы быстрых платежей. Вдобавок к этому, мы расширили наши возможности и теперь доступна оплата и для юридических лиц. Юридические лица могут самостоятельно генерировать счета для оплаты.': '我們很高興地宣布，您現在可以使用銀行卡或快捷支付系統的二維碼在我們的網站上支付申請費用。 除此之外，我們還擴展了我們的能力，現在法人實體也可以付款。 法律實體可以獨立生成付款發票。',
    'Никаких задержек и лишних хлопот - оплата проходит мгновенно. Перейдите в раздел "Оплата заявок" и оплачивайте свои заявки быстро и удобно! Наши новые возможности сделают процесс ещё более удобным и эффективным.': '沒有延誤和不必要的麻煩 - 付款是即時的。 前往“付款”部分，快速方便地為您的申請付款！ 我們的新功能將使該過程更加方便和高效。',

    // помощь
    'У вас есть вопросы?': '您有问题？?',
    'Если вы не можете найти ответ на вопрос, вы всегда можете связаться с нами. Мы ответим вам в ближайшее время!': '如果您没有找到问题的答案，您可以和我们取得联系。我们将在近期回复您！',
    'Мы всегда рады помочь!': '我们非常愿意给您提供帮助',
    'Лучший способ получить ответ быстрее!': '更快地获得答案的最佳方法！',

    // в разработе
    'Готовимся к запуску. Новая функция в пути! 🚀': '準備發射。 新功能即將推出！ 🚀',
    'Мы активно работаем над новой функцией для вас.': '我們正在積極為您開發一項新功能。',
    'Будьте в курсе предстоящих обновлений!': '請繼續關注即將推出的更新！',

    // Обратная связь
    'Мы всегда рады услышать вас!': '我们总是很高兴的收到您的信息',
    'Наши усилия направлены на то, чтобы сделать систему подачи заявок максимально удобной и эффективной для вас. Ваше мнение и предложения играют ключевую роль в этом процессе. Не стесняйтесь делиться своими мыслями, идеями, а также сообщать нам обо всех замеченных ошибках или проблемах в работе системы. Вместе мы сделаем систему подачи заявок лучше!': '我们的努力是为了使申请系统对您来说尽可能方便和高效。 您的意见和建议在这一过程中起着关键作用。 请随时分享您的想法和想法，并告诉我们有关系统中发现的所有错误或问题。 我们将共同使申请系统变得更好！',
    'Как к вам обращаться?': '如何称呼您？',
    'Email для обратной связи': '和您取得联系的邮箱',
    'Опишите ваше предложение, жалобу или замеченную ошибку': '请填写您的建议，投诉和发现的错误',
    'Мы используем файлы cookie, чтобы сайт работал и был удобнее. Оставаясь на сайте, вы соглашаетесь на их использование.': '我们使用 Cookie，以保证网站正常运行并提升使用体验。继续浏览本网站，即表示您同意使用 Cookie。',
    'Хорошо': '知道了',
    'Подача графика на {month} закрывается {deadline}.': '{month}的表格提交将于{deadline}截止。',
    'Россия': '俄罗斯',

    // оплата лицензий
    'Оплата продления': '续期付款',
    'Оплатить': '支付',
    'К заказам': '返回订单',
    'Повторить': '重试',
    'Выбор лицензий': '选择许可证',
    'Выберите одну или несколько лицензий для оплаты': '选择一个或多个需要付款的许可证',
    'Сезон продления: приём заявок с {start} по {finish}': '续期季：{start} 至 {finish} 接受申请',
    'Выберите лицензии': '选择许可证',
    'Нет лицензий для оплаты': '没有可付款的许可证',
    'Итого к оплате': '应付总额',
    'Плательщик': '付款人',
    'ФИО и email, на который придёт чек': '姓名及接收收据的电子邮箱',
    'Проверьте список лицензий и перейдите к оплате': '核对许可证列表并前往付款',
    'Лицензия № {no}': '许可证编号 {no}',
    'После оплаты менеджер получит уведомление и отметит оплату. Чек придёт на указанный email.': '付款后，经理会收到通知并登记付款。收据将发送到您填写的电子邮箱。',
    'Продление уже оплачено': '续期已付款',
    'Оплачено на сайте, ждёт подтверждения менеджера': '已在网站付款，等待经理确认',
    'Оплата лицензий пока недоступна.': '许可证付款暂不可用。',
    'Цены на лицензии ещё не опубликованы. Попробуйте позже или свяжитесь с менеджером.': '许可证价格尚未公布。请稍后再试或联系经理。',
    'Не удалось получить список лицензий. Попробуйте ещё раз.': '无法获取许可证列表。请重试。',
    'Не удалось создать счёт на оплату. Попробуйте ещё раз.': '无法创建付款账单。请重试。',
    'Список лицензий или цены изменились. Обновите страницу и выберите лицензии заново.': '许可证列表或价格已变更。请刷新页面并重新选择许可证。',
    'Введите email': '请输入电子邮箱',
    'Введите ваш email': '请输入您的电子邮箱',
    'Продление этой лицензии сейчас закрыто': '该许可证目前无法续期',
    'Укажите язык лицензии в разделе «Мои лицензии»': '请在“我的许可证”中填写许可证语言',
    'Заявка на продление подана': '续期申请已提交',
    'Заявка на продление будет подана автоматически': '续期申请将自动提交',
    'Заявку на продление оформит менеджер': '续期申请将由经理办理',
    'Добавьте свои лицензии в раздел «Мои лицензии», и заявки на продление будут подаваться автоматически.': '将您的许可证添加到“我的许可证”，续期申请即可自动提交。',
    'Консультационные услуги (лицензии)': '咨询服务（许可证）',
    'Продление или первичное получение, затем музей': '续期或首次办理，然后选择博物馆',
    'Первичное получение': '首次办理',
    'первичное получение': '首次办理',
    'Оплата в офисе': '在办公室付款',
    'Итого к оплате на сайте': '网站应付总额',
    'ФИО для договора, телефон и email, на который придёт чек': '合同用的姓名、电话及接收收据的电子邮箱',
    'ФИО': '姓名',
    'Фамилия Имя Отчество': '姓、名、父称',
    'Введите ФИО полностью': '请输入完整姓名',
    'Контактный телефон': '联系电话',
    'Введите корректный телефон': '请输入正确的电话号码',
    'Договор и оплата': '合同与付款',
    'Проверьте список, подтвердите договор и перейдите к оплате': '核对列表、确认合同并前往付款',
    'Заявки на продление поданы.': '续期申请已提交。',
    'Оплата этих лицензий производится в офисе. Для справок свяжитесь с менеджером по телефону {phone}.': '这些许可证需在办公室付款。如有疑问，请致电经理：{phone}。',
    'Договор оказания услуг': '服务合同',
    'Не удалось получить текст договора. Попробуйте ещё раз.': '无法获取合同文本。请重试。',
    'Я принимаю условия договора возмездного оказания услуг': '我接受有偿服务合同条款',
    'Подать заявки': '提交申请',
    'Выбор группы откроется после оплаты продления.': '付款后即可选择小组。',
    'Оплатить продление': '支付续期费用',
    'Продление оплачено на сайте.': '续期已在网站付款。',
    'Не удалось записаться в группу. Попробуйте ещё раз.': '无法加入小组。请重试。',
    'Выбрать группу': '选择小组',
    'Теперь можно выбрать группу для занятий: она появится в карточке музея на странице «Продление», как только менеджер назначит даты.': '现在可以选择课程小组：经理确定日期后，它会显示在“续期”页面的博物馆卡片中。',
    'Тестовый режим': '测试模式',
    'Раздел проверяется, оплачивать лицензии через сайт пока не нужно.': '本栏目正在测试中，暂时无需通过网站支付执照费用。',
    'истекла': '已过期',
    'Не удалось удалить лицензию. Попробуйте ещё раз.': '无法删除证件，请重试。',
    'Не удалось добавить лицензию. Попробуйте ещё раз.': '无法添加证件，请重试。',
    'Расписание занятий': '课程安排',
    'Расписание занятий пока не опубликовано.': '课程安排尚未公布。',
    'Расписание занятий появится после записи.': '报名后将显示课程安排。',
    'Стоимость занятий': '课程费用',
    'Записаться на продление': '报名延期',
    'Оплатить занятия': '支付课程费用',
    'Выбрать дату занятий': '选择上课日期',
    'Подать заявку на продление: {museum}? После этого станет видно расписание занятий.': '提交延期申请：{museum}？提交后即可查看课程安排。',
    'Продление по этому музею сейчас закрыто.': '该博物馆目前不接受延期。',
    'Укажите в лицензии язык: без него заявку не принять. Это можно сделать через «Изменить».': '请在证件中注明语言，否则无法受理申请。可通过“Изменить”完成。',
    'Лицензия продлена.': '证件已延期。',
    'Заявка на продление подана.': '延期申请已提交。',
    'Занятия оплачены.': '课程费用已支付。',
    'Занятия оплачены на сайте, менеджер подтвердит оплату.': '已在网站支付课程费用，经理将确认付款。',
    'Вы записаны на занятия: {group}.': '您已报名课程：{group}。',
    'Не удалось подать заявку. Попробуйте ещё раз.': '无法提交申请，请重试。',
    'Занятия оплачены. Выберите дату занятий в карточке: {museums}.': '课程费用已支付。请在卡片中选择上课日期：{museums}。',
    'Укажите язык лицензии на странице «Продление лицензий»': '请在“证件延期”页面注明证件语言',
    'Сначала добавьте лицензию на странице «Продление лицензий»': '请先在«执照延期»页面添加执照',
    'Оплата возвращена, можно оплатить заново': '款项已退还，可重新支付',
    'свободно {free} из {limit}': '剩余{free}/{limit}个名额',
    'мест нет': '没有名额',
    'Добавьте свои лицензии на странице «Продление лицензий», и заявки на продление будут подаваться автоматически.': '请在“证件延期”页面添加您的证件，延期申请将自动提交。',
    'Теперь можно выбрать дату занятий по расписанию: откройте карточку лицензии на странице «Продление лицензий».': '现在可以按课程安排选择上课日期：请在“证件延期”页面打开证件卡片。',
    'Лицензии': '证件',
    'Подать заявку': '提交申请',
    'Выбрать': '选择',
    'Стоимость пока не указана.': '费用尚未确定。',
    'Лицензии на этот музей нет в кабинете. Добавьте её, чтобы записаться на продление и оплатить занятия.': '您的账户中没有该博物馆的证件。请添加证件，以便报名延期并支付课程费用。',
    'Музеи, где у вас нет лицензии': '您没有证件的博物馆',
    'С окончания срока действия лицензии прошло 3 года. Просьба обратиться к менеджеру за консультацией.': '证件过期已满三年。请联系经理咨询。',
    'Прошло три года после окончания лицензии — нужно первичное обучение': '证件过期已满三年——需要参加初次培训',
    'Просим вас вписать ФИО полностью и кириллицей: это нужно для соблюдения законодательства РФ.': '请用西里尔字母（俄文）填写完整姓名：这是遵守俄罗斯法律的要求。',
    'Введите ФИО кириллицей — допустимы только буквы, пробел и дефис': '请用西里尔字母（俄文）填写姓名，只能包含字母、空格和连字符',
    'Оплатите занятия и после этого выберите дату и время.': '请先支付课程费用，然后选择日期和时间。',
    'Выбрать дату и время занятий можно будет после подтверждения менеджера.': '经理确认后即可选择课程的日期和时间。',
    'Поиск по лицензиям': '搜索证件',
    'Музей или номер лицензии': '博物馆或证件号码',
    'Ничего не найдено': '未找到任何内容',
    'Договоры оказания услуг': '服务合同',
    'Договор на продление': '延期合同',
    'Договор на первичное обучение': '初次培训合同',
    'Я принимаю условия договоров возмездного оказания услуг': '我接受有偿服务合同的条款',
    'Email:': '邮箱',
    'После оплаты договор сохранится в «Настройках» и в «Истории платежей»: его можно открыть и скачать в PDF.': '付款后，合同将保存在“设置”和“付款记录”中，可打开并下载 PDF。',
    'После оплаты договоры сохранятся в «Настройках» и в «Истории платежей»: их можно открыть и скачать в PDF.': '付款后，合同将保存在“设置”和“付款记录”中，可打开并下载 PDF。',
    'Договоры оказания услуг, которые вы подписали при оплате лицензий. Их можно открыть и скачать в любой момент.': '您在支付许可证费用时签署的服务合同，可随时打开和下载。',
    'от {date}, платёж № {payment}': '{date}，付款编号 {payment}',
    'оплата возвращена': '款项已退还',
    'Скачать PDF': '下载 PDF',
    'Вы согласились с условиями договора и подписали его {date} в {time}, отметив «{label}».': '您已同意合同条款，并于 {date} {time} 勾选“{label}”签署了合同。',
    'Не удалось получить договор. Попробуйте ещё раз.': '无法获取合同，请重试。',

    // получение лицензий (правка начальника 02.10.2026)
    'Получение лицензий': '获取许可证',
    'Можно оплатить': '可以付款',
    'Отметьте музеи и отправьте заявку.': '勾选博物馆并提交申请。',
    'Дождитесь даты обучения — она появится здесь.': '等待培训日期——它会显示在这里。',
    'Выберите дату и оплатите обучение.': '选择日期并支付培训费用。',
    'Приём заявок с {start} по {finish}': '申请受理时间：{start} 至 {finish}',
    'Получение лицензий сейчас недоступно.': '目前无法获取许可证。',
    'Мои заявки': '我的申请',
    'Новая заявка': '新申请',
    'Стоимость обучения': '培训费用',
    'Приём заявок сейчас закрыт.': '目前不受理申请。',
    'Отправить заявку': '提交申请',
    'Заявка отправлена: {museums}. Когда появится дата обучения, вы сможете выбрать её и оплатить.': '申请已提交：{museums}。培训日期公布后，您可以选择日期并付款。',
    'Заявки отправлены: {museums}. Когда появится дата обучения, вы сможете выбрать её и оплатить.': '申请已提交：{museums}。培训日期公布后，您可以选择日期并付款。',
    'Заявка отправлена: {museums}. Дата обучения уже есть — выберите её в «Моих заявках» и оплатите.': '申请已提交：{museums}。培训日期已公布——请在“我的申请”中选择日期并付款。',
    'Заявки отправлены: {museums}. Дата обучения уже есть — выберите её в «Моих заявках» и оплатите.': '申请已提交：{museums}。培训日期已公布——请在“我的申请”中选择日期并付款。',
    'Не удалось получить список заявок. Попробуйте ещё раз.': '无法获取申请列表，请重试。',
    'Язык: {langs}': '语言：{langs}',
    'Языки: {langs}': '语言：{langs}',
    'Заявка подана. Дата обучения пока не назначена. Когда она появится, вы сможете выбрать дату и оплатить обучение.': '申请已提交。培训日期尚未确定。日期公布后，您可以选择日期并支付培训费用。',
    'Заявка подана. Выберите дату обучения и оплатите.': '申请已提交。请选择培训日期并付款。',
    'Заявка подана. Дата обучения: {group}.': '申请已提交。培训日期：{group}。',
    'Заявка подана.': '申请已提交。',
    'Дата обучения': '培训日期',
    'Дата обучения: {group}': '培训日期：{group}',
    'Даты обучения': '培训日期',
    'Оплата этого обучения производится в офисе. Для справок свяжитесь с менеджером по телефону {phone}.': '此培训需在办公室付款。如有疑问，请致电经理：{phone}。',
    'Заявка подана. Стоимость обучения пока не указана — оплата откроется позже.': '申请已提交。培训费用尚未确定——付款将稍后开放。',
    'Обучение оплачено. Записываем вас на {date}. Если запись не появится — позвоните менеджеру: {phone}.': '培训费用已支付。正在为您报名 {date}。如果报名信息未出现，请致电经理：{phone}。',
    'Обучение оплачено.': '培训费用已支付。',
    'Обучение оплачено. Дату обучения сообщит менеджер.': '培训费用已支付。经理会通知您培训日期。',
    'Записать вас на {date} не получилось: {reason}': '未能为您报名 {date}：{reason}',
    'Выберите другую дату.': '请选择其他日期。',
    'Дату обучения сообщит менеджер: {phone}.': '经理会通知您培训日期：{phone}。',
    'Обучение оплачено. Вы записаны: {group}.': '培训费用已支付。您已报名：{group}。',
    'Обучение пройдено.': '培训已完成。',
    'Лицензия № {no}, действует до {date}.': '许可证编号 {no}，有效期至 {date}。',
    'Оплата на сайте пока недоступна. Свяжитесь с менеджером: {phone}.': '网站付款暂不可用。请联系经理：{phone}。',
    'Изменить языки или отменить заявку можно через менеджера: {phone}.': '如需更改语言或取消申请，请联系经理：{phone}。',
    'Место в группе закрепляется после оплаты.': '付款后才会保留您在小组中的名额。',
    'Выбрать дату': '选择日期',
    'Оплата обучения': '培训付款',
    'Получаете лицензию впервые?': '首次获取许可证？',
    'Вам в раздел «Получение лицензий»': '请前往“获取许可证”栏目',
    'К заявкам': '返回申请',
    'Обучение и дата': '培训与日期',
    'Музей и дата обучения': '博物馆和培训日期',
    'Музеи, по которым продлеваете лицензию': '您要延期许可证的博物馆',
    'Оплата обучения на сайте пока недоступна.': '网站上的培训付款暂不可用。',
    'Оплачивать пока нечего. Оплата откроется после заявки, когда появится дата обучения.': '暂无可支付的项目。提交申请并公布培训日期后即可付款。',
    'Дата обучения ещё не назначена': '培训日期尚未确定',
    'Выбранная дата обучения больше недоступна. Выберите дату заново.': '所选培训日期已不可用，请重新选择日期。',
    'Обучение оплачено. Запись на выбранную дату появится на странице «Получение лицензий».': '培训费用已支付。所选日期的报名信息将显示在“获取许可证”页面。',
    'К моим заявкам': '前往我的申请',
    'К оплате продления': '前往续期付款',
    'Появилась дата обучения: {museums}. Можно выбрать дату и оплатить.': '培训日期已公布：{museums}。现在可以选择日期并付款。',
    'Обучение оплачено, выберите дату: {museums}.': '培训费用已支付，请选择日期：{museums}。',
    'Перейти': '前往',
    'Перейти к получению лицензии': '前往获取许可证',
    'Не удалось получить список языков.': '无法获取语言列表。',
    'Дата обучения прошла.': '培训日期已过。',
    'Лицензия по этому музею у вас уже есть. Обратитесь к менеджеру.': '您已持有该博物馆的许可证。请联系经理。',
    'Заявки отправлены: {museums}. Дата обучения уже есть: {dated} — выберите её в «Моих заявках» и оплатите.': '申请已提交：{museums}。以下博物馆的培训日期已公布：{dated}——请在“我的申请”中选择日期并付款。',
    'Выберите дату обучения по каждому музею.': '请为每个博物馆选择培训日期。',
    'Система заявок сейчас не отвечает. Попробуйте через минуту.': '申请系统暂时没有响应。请一分钟后重试。',
    'Подтвердите договор оказания услуг.': '请确认服务合同。',
    'Лицензия не указана.': '未指定许可证。',
    'Лицензия не найдена.': '未找到许可证。',
    'Выберите хотя бы одну лицензию.': '请至少选择一个许可证。',
    'Введите ФИО кириллицей — допустимы только буквы, пробел и дефис.': '请用西里尔字母填写姓名——只能使用字母、空格和连字符。',
    'Не выбран музей.': '未选择博物馆。',
    'Выберите язык: без него заявку на обучение не примут.': '请选择语言：否则培训申请不会被受理。',
    'Так записаться можно только на первичное обучение.': '此方式仅可报名初次培训。',
    'Выбор даты откроется после оплаты обучения.': '支付培训费用后即可选择日期。',
    'Введите ФИО полностью.': '请输入完整姓名。',
    'Введите корректный телефон.': '请输入正确的电话号码。',
    'Введите корректный email.': '请输入正确的电子邮箱。',
    'Система заявок отклонила запрос. Попробуйте ещё раз или свяжитесь с оператором.': '申请系统拒绝了请求。请重试或联系操作员。',
    'Первичное получение, продление': '初次获取、续期',
    'Мои договоры': '我的合同',
    'Подписанных договоров пока нет. Они появятся здесь после оплаты продления или обучения на сайте.': '暂无已签署的合同。在网站上支付续期或培训费用后，合同将显示在此处。',
    'Здесь можно заказать технические средства ведения экскурсий': '在这里可以预订导览技术设备',

    // Прайс-лист с ценами (09.10.2026)
    'Ваши цены': '您的价格',
    'Персональный прайс-лист': '个人价目表',
    'Общий прайс-лист': '通用价目表',
    'действует с': '生效日期',
    'Объект': '对象',
    'Основная цена': '标准价格',
    'Льготная цена': '优惠价格',
    'Стоимость по прайс-листу:': '价目表价格：',
    'без учёта:': '不含：',

    // Прайс-листы по категориям групп (12.10.2026)
    'Российские туристы': '俄罗斯游客',
    'Иностранные туристы': '外国游客',
    'Китайские туристы': '中国游客',
    'Школьная группа': '学生团',
    'Школьные группы': '学生团体',
    'Основная': '标准',
    'Льготная': '优惠',
    'За группу': '团体',
    'Группа до {n} чел.': '团体最多{n}人',
    'Экскурсионное обслуживание': '讲解服务',
    'Обслуживание до {n} чел.': '讲解服务，最多{n}人',
    'ЭО': '讲解',
    'Экскурсионное обслуживание, за одно': '讲解服务，每次',
    'экскурсионное обслуживание': '讲解服务',
    'VIP': 'VIP',
    'за группу': '每团',
    'Нажмите на заголовок, чтобы раскрыть цены, на название музея — его объекты': '点击标题展开价格，点击博物馆名称展开其项目',
    'ШКОЛЬНАЯ': '学生团',
    'Цена за группу': '团体价格',
    'до {n} чел.': '最多{n}人',
    'Услуги в заявке в музей': '博物馆订单中的服务',
    'за человека': '每人',
    'за доставку': '每次配送',
    'Калькулятор цен': '价格计算器',
    'Выберите музей, объект и количество билетов — стоимость посчитается по вашему прайс-листу': '选择博物馆、设施和门票数量，费用将按您的价目表计算',
    'Дата нужна, чтобы взять прайс-лист, действующий на день посещения': '日期用于选取参观当天有效的价目表',
    'При группе от {n} человек требуется радиогид': '{n}人及以上的团组须使用无线讲解器',
    'Стоимость': '费用',
    'Выберите музей и объект — расчёт появится здесь': '选择博物馆和设施，计算结果将显示在这里',
    'Укажите количество билетов': '请输入门票数量',
    'Считаем…': '计算中…',
    'Для этого объекта цены в прайс-листе нет. Сумму рассчитает менеджер после подачи заявки.': '价目表中没有该设施的价格。提交订单后由经理计算金额。',
    'Расчёт недоступен: войдите в кабинет заново': '无法计算：请重新登录',
    'Итого': '合计',
    'У этих услуг нет цены в прайс-листе — её уточнит менеджер.': '这些服务在价目表中没有价格，经理将另行确认。',
    'Основные билеты': '全价票',
    'Льготные билеты': '优惠票',
    '{n} чел.': '{n}人',
    'Хотите рассчитать цену?': '想计算价格吗？',
    'Воспользуйтесь нашим калькулятором: выберите музей, объект и количество билетов — сумма посчитается по вашему прайс-листу.': '使用我们的计算器：选择博物馆、设施和门票数量，金额将按您的价目表计算。',
    'Открыть калькулятор': '打开计算器',
    'Изменить номер': '修改编号',
    'Изменить номер лицензии': '修改执照编号',
    'Не удалось изменить номер лицензии. Попробуйте ещё раз.': '无法修改执照编号，请重试。',
    'Расчёт по группам': '按团组计算',
    'Музеев в расчёте': '计算中的博物馆',
    'Итого по всем группам': '所有团组合计',
    'Очистить расчёт': '清空计算',
    'Группа добавлена в расчёт. Выберите следующий музей — количество билетов подставится прежнее.': '团组已加入计算。请选择下一个博物馆，门票数量将沿用上一次。',
    'чел.': '人',
    'Убрать': '移除',
    'Вместе с добавленными группами ({n})': '连同已添加的团组（{n}）',
    'Расчёт стоимости': '费用计算',
    'Заголовок документа': '文档标题',
    'Не удалось подготовить файл. Попробуйте ещё раз.': '无法生成文件，请重试。',
    'доставка': '配送',
    'Скачать расчёт': '下载计算结果',
    'новое': '新',
    'Подача заявок по расчёту': '按计算提交订单',
    'На каждый музей уйдёт отдельная заявка. Выберите время посещения и укажите данные гида.': '每个博物馆将单独提交订单。请选择参观时间并填写导游信息。',
    'На эту дату записи нет — измените дату в калькуляторе': '该日期无可预约时间，请在计算器中更改日期',
    'выберите время': '请选择时间',
    'это время больше недоступно, выберите другое': '该时间已不可用，请选择其他时间',
    'Отправлено заявок: {n}': '已提交订单：{n}',
    'Причина': '原因',
    'До сбоя в офис успели уйти заявки {list} — они уже в «Заказах», подавать их заново не нужно.': '故障前订单 {list} 已送达办公室，已在“订单”中，无需重复提交。',
    'Остальные музеи оставлены в расчёте — исправьте и отправьте заново.': '其余博物馆仍保留在计算中，请修正后重新提交。',
    'Успешно': '成功',
    'Заявка не отправлена': '订单未提交',
    'Заявка на эту дату не принимается: не раньше чем за {n} дн. — измените дату в калькуляторе': '该日期不接受订单：需至少提前 {n} 天，请在计算器中更改日期',

    // Калькулятор стоимости лицензий и выбор калькулятора (27.10.2026).
    'Билеты, экскурсионное обслуживание и услуги по вашему прайс-листу. Расчёт можно скачать и сразу подать заявку.': '按您的价目表计算门票、讲解服务和其他服务。可下载计算结果并立即提交申请。',
    'Выберите, что посчитать': '选择要计算的内容',
    'Из них оплачивается в офисе': '其中在办公室支付',
    'К выбору калькулятора': '返回选择计算器',
    'К получению лицензий': '前往获取许可证',
    'Расчёт стоимости заявки': '申请费用计算',
    'Расчёт стоимости лицензий': '许可证费用计算',
    'Не удалось получить цены. Попробуйте ещё раз.': '无法获取价格。请重试。',
    'Оплачивается в офисе': '在办公室支付',
    'Отметьте музеи слева — здесь появится расчёт.': '在左侧勾选博物馆，计算结果将显示在此处。',
    'Отметьте музеи — стоимость посчитается по ценам текущего сезона': '勾选博物馆，费用将按本季价格计算',
    'Очистить': '清除',
    'Первичное получение (обучение)': '首次获取（培训）',
    'Продление и получение лицензий по ценам текущего сезона. Расчёт можно скачать и перейти к оплате.': '按本季价格续期和获取许可证。可下载计算结果并前往支付。',
    'Продление лицензии': '许可证续期',
    'Сезон': '季度',
    'Цены на этот сезон пока не заведены. Уточните стоимость по телефону {phone}.': '本季价格尚未设置。请致电 {phone} 咨询费用。',
    'лицензий: {n}': '许可证：{n}',
    'Цены на сезон пока нет — уточните по телефону {phone}.': '本季价格尚未设置，请致电 {phone} 咨询。',

    // Договор при отметке «Согласие» (28.10.2026).
    'Вы согласились с условиями договора и подписали его {date} в {time}, нажав «Согласие».': '您于 {date} {time} 勾选“同意”，接受了合同条款并签署了合同。',
    'Договор подписан и сохранён в «Настройках».': '合同已签署并保存在“设置”中。',
    'Договоры оказания услуг, которые вы подписали отметкой «Согласие» при оплате лицензий. Их можно открыть и скачать в любой момент.': '您在支付许可证时勾选“同意”签署的服务合同。可随时打开和下载。',
    'Договоры подписаны и сохранены в «Настройках».': '合同已签署并保存在“设置”中。',
    'Не удалось сохранить договор. Попробуйте ещё раз.': '无法保存合同。请重试。',
    'Подписанных договоров пока нет. Они появятся здесь, как только вы отметите «Согласие» на шаге оплаты продления или обучения.': '尚无已签署的合同。当您在续期或培训的支付步骤勾选“同意”后，合同将显示在此处。',
    'После отметки «Согласие» договор сохранится в «Настройках»: его можно открыть и скачать в PDF в любой момент.': '勾选“同意”后，合同将保存在“设置”中：可随时打开并下载 PDF。',
    'После отметки «Согласие» договоры сохранятся в «Настройках»: их можно открыть и скачать в PDF в любой момент.': '勾选“同意”后，合同将保存在“设置”中：可随时打开并下载 PDF。',
    'Согласие: я принимаю условия договора возмездного оказания услуг': '同意：我接受有偿服务合同的条款',
    'Согласие: я принимаю условия договоров возмездного оказания услуг': '同意：我接受有偿服务合同的条款',
    'Сохраняем договор…': '正在保存合同…',
    'ожидает оплаты': '待付款',
    'от {date}': '日期 {date}',

    // Расчёт стоимости: радиогид/аудиогид, итоги в множественных заявках (30.10.2026)
    'Что считаем': '计算内容',
    'Заявка в музей': '博物馆申请',
    'Радиогид в город': '城市无线导览',
    'Радиогид в музей': '博物馆无线导览',
    'Выберите музей — расчёт появится здесь': '选择博物馆，计算结果将显示在此处',
    'Укажите количество аппаратов': '请输入设备数量',
    'Для этой услуги цены в прайс-листе нет. Сумму рассчитает менеджер после подачи заказа.': '价目表中没有此服务的价格。下单后由经理计算金额。',
    'Заказать радиогид / аудиогид': '订购无线导览 / 语音导览',
    'В расчёте есть заказ радиогида или аудиогида: такие заказы подаются в разделе «Радиогид / Аудиогид», заявки в музеи — из расчёта без него.': '计算中包含无线导览或语音导览订单：此类订单请在“无线/语音导览”栏目下单，博物馆申请请从不含它的计算中提交。',
    'Доставка': '配送',
    'за пределами КАД': '环城公路外',
    'в пределах КАД': '环城公路内',
    'доставка в пределах КАД': '环城公路内配送',
    'Аппараты': '设备',
    'аппараты': '设备',
    'Заказ добавлен в расчёт.': '订单已加入计算。',
    'оценено музеев: {n} из {total}': '已计价博物馆：{n}/{total}',
    'оценено групп: {n} из {total}': '已计价团组：{n}/{total}',
    'Кол-во аппаратов': '设备数量',
    'Оформить доставку (услуга платная)': '订购配送（收费服务）',
    'Доставка в пределах КАД': '环城公路内配送',
    'Доставка за пределы КАД': '环城公路外配送',
}
